var render, staticRenderFns
import script from "./DistanceComparisonChart.vue?vue&type=script&lang=js&"
export * from "./DistanceComparisonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586e536",
  null
  
)

export default component.exports